export enum VendorType {
  supplier = 'supplier',
  contractor = 'contractor',
  serviceProvider = 'service_provider',
  consultant = 'consultant',
  software = 'software',
  other = 'other',
}

export enum VendorStatus {
  active = 'active',
  inactive = 'inactive',
  pending = 'pending',
  suspended = 'suspended',
}

export enum PurchaseOrderStatus {
  draft = 'draft',
  pending = 'pending',
  approved = 'approved',
  sent = 'sent',
  received = 'received',
  cancelled = 'cancelled',
}

export enum InvoiceStatus {
  draft = 'draft',
  pending = 'pending',
  approved = 'approved',
  paid = 'paid',
  overdue = 'overdue',
  cancelled = 'cancelled',
}

export interface Vendor {
  id: string;
  name: string;
  type: VendorType;
  status: VendorStatus;
  contactName?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  website?: string;
  taxId?: string;
  paymentTerms?: string; // e.g., "Net 30"
  rating?: number; // 1-5 stars
  notes?: string;
  tags: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface PurchaseOrder {
  id: string;
  vendorId: string;
  vendorName: string;
  poNumber: string;
  status: PurchaseOrderStatus;
  orderDate: Date;
  expectedDeliveryDate?: Date;
  items: PurchaseOrderItem[];
  subtotal: number;
  tax: number;
  shipping: number;
  total: number;
  notes?: string;
  approvedBy?: string;
  approvedAt?: Date;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PurchaseOrderItem {
  id: string;
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
  category?: string;
}

export interface VendorInvoice {
  id: string;
  vendorId: string;
  vendorName: string;
  invoiceNumber: string;
  poNumber?: string;
  status: InvoiceStatus;
  invoiceDate: Date;
  dueDate: Date;
  items: InvoiceItem[];
  subtotal: number;
  tax: number;
  total: number;
  amountPaid: number;
  balance: number;
  paymentDate?: Date;
  paymentMethod?: string;
  notes?: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface InvoiceItem {
  id: string;
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
  category?: string;
}

export interface VendorContract {
  id: string;
  vendorId: string;
  vendorName: string;
  contractNumber: string;
  title: string;
  startDate: Date;
  endDate?: Date;
  autoRenew: boolean;
  value: number;
  terms?: string;
  fileUrl?: string;
  status: 'active' | 'expired' | 'terminated' | 'pending';
  renewalDate?: Date;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

